export const enabledColor = '#1677ff';
export const disabledColor = '#b8b8b8';
//# sourceMappingURL=styles.js.map